import React, { useEffect, useState } from 'react';
import moment from 'moment';

import {
	TemplateDate,
	TemplateEditor,
	TemplateField,
} from '../../../components/Attributes/Attributes_old';
import Modal from '../../../components/Shell/Modal';
import { Button } from '../../../components/Button';

import useModal from '../../../hooks/useModal';
import usePrevious from '../../../hooks/usePrevious';
import useAsync from '../../../hooks/useAsync';

import { betaCreateOrganization } from '../../../api/admin';

const MODAL_NAME = 'addOrganization';
const DEFAULT_FORM = {
	expires: moment().add(24, 'hours').toDate(),
};

const AddOrganizationModal = () => {
	const { open, setClose } = useModal(MODAL_NAME);
	const [form, setForm] = useState(DEFAULT_FORM);

	const { execute: onCreateOrganization } = useAsync(betaCreateOrganization, {
		immediate: false,
		showNotification: {
			error: 'raw',
		},
	});

	const prevOpen = usePrevious(open);
	useEffect(() => {
		if (!open && prevOpen) {
			setForm(DEFAULT_FORM);
		}
	}, [open]);

	return (
		<Modal
			title="Create an Organization"
			name={MODAL_NAME}
			open={open}
			onClose={() => setClose()}
		>
			<div className="grid grid-cols-2 gap-y-4">
				<TemplateField
					name="Name"
					onChange={(index, name) => setForm({ ...form, name })}
					value={form?.name}
				/>

				<TemplateEditor
					name="Address"
					optional
					toolbar={false}
					onChange={(index, address, raw) => setForm({ ...form, address: raw })}
					value={form?.address?.delta}
					placeholder="Organization address"
				/>

				<TemplateField
					name="Customer email"
					optional
					onChange={(index, email) => setForm({ ...form, email })}
					value={form?.email}
				/>

				<TemplateField
					name="Customer First Name"
					optional
					onChange={(index, firstName) => setForm({ ...form, firstName })}
					value={form?.firstName}
				/>
				<TemplateField
					name="Customer Last Name"
					optional
					onChange={(index, lastName) => setForm({ ...form, lastName })}
					value={form?.lastName}
				/>

				<TemplateDate
					name="Expires"
					optional
					onChange={(index, expires) => setForm({ ...form, expires })}
					value={form?.expires}
				/>

				<div className="flex justify-end col-span-2">
					<Button
						onClick={() => {
							const { address } = form;
							onCreateOrganization({ ...form, address: address?.content }, () =>
								setClose()
							);
						}}
					>
						Create
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default AddOrganizationModal;
